import React from 'react';
import './Carousel.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import CarouselItem from './CarouselItem';

const CarouselWrapper = (props) => {
  console.log(props.slideId);
  const data = window.slideshows[props.slideId];
  console.log(data);

  return (
    <Carousel preventMovementUntilSwipeScrollTolerance swipeScrollTolerance={100} centerMode={false} showThumbs={false} infiniteLoop={false} autoPlay interval={3000} >
      {data?.map((slide) => (
        <CarouselItem
          primaryColor={slide.primaryColor}
          title={slide.title}
          subTitle={slide.subTitle}
          ctaText={slide.ctaText}
          ctaLink={slide.ctaLink}
          imgUrl={slide.imgUrl}
          countdownText={slide.countdownText}
          countdownDate={slide.countdownDate}
        />
      ))}
    </Carousel>
  );
};

export default CarouselWrapper;
